import { withCustomLinkComponent } from '@module/mdrt-org/shared/i18n/with-custom-link-component';
import {
  RecommendationCard as RecommendationCardBase,
  type RecommendationCardProps,
} from '@shared/ui-components/player/components/recommedation-card/recommendation-card';

export const RecommendationCard = (props: Omit<RecommendationCardProps, 'LinkComponent'>) =>
  withCustomLinkComponent(RecommendationCardBase, props);
